export const getNewContractorResponseSchema = {
  type: "object",
  properties: {
    contractorId: {
      type: "string",
    },
  },
  required: ["contractorId"],
  additionalProperties: true,
};
